import type { EventCatalogEntry } from "@repo/vihangam-yog-shared";

import { trpc } from "../../trpc";

import { kundCount, kundLine } from "./kunds";

/**
 * "489 Kunds left", with a thin bar underneath showing how far along the
 * Yajna is.
 * Renders nothing while the count is unknown: an event that isn't
 * Kund-based, a query that hasn't answered yet, or one that failed. A
 * missing line is calmer than a wrong number.
 */
export function KundCounter({ event }: { event: EventCatalogEntry }) {
  const availability = trpc.eventTierAvailability.useQuery(
    { eventSlug: event.slug },
    { staleTime: 30_000 },
  );
  if (!availability.data || availability.isError) {
    return null;
  }
  const count = kundCount(event, availability.data);
  if (!count) {
    return null;
  }
  const pct = count.total > 0 ? (count.taken / count.total) * 100 : 0;
  return (
    <div className="mt-3">
      <p className="text-sm font-semibold text-ink" data-testid="kund-counter">
        {kundLine(count)}
      </p>
      <div
        className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-ivory-deep"
        role="progressbar"
        aria-label="Kunds taken"
        aria-valuemin={0}
        aria-valuemax={count.total}
        aria-valuenow={count.taken}
      >
        <div
          className="h-full rounded-full bg-teal-deep transition-[width] duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
